import { Link, routes } from '@redwoodjs/router'
import { Toaster } from '@redwoodjs/web/toast'

type EquipmentLayoutProps = {
  children: React.ReactNode
}

const EquipmentsLayout = ({ children }: EquipmentLayoutProps) => {
  return (
    <div className="rw-scaffold">
      <Toaster />
      <header className="rw-header">
        <h1 className="rw-heading rw-heading-primary">
          <Link
            to={routes.equipments()}
            className="rw-link"
          >
            Equipments
          </Link>
        </h1>
        <Link
          to={routes.newEquipment()}
          className="rw-button rw-button-green"
        >
          <div className="rw-button-icon">+</div> New Equipment
        </Link>
      </header>
      <main className="rw-main">{children}</main>
    </div>
  )
}

export default EquipmentsLayout
